import { Map } from "ol";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import { Vector as VectorLayer } from "ol/layer";
import LayerGroup from "ol/layer/Group";
import { BerthListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { berthToMapItem } from "./dataConverters";

export function addBerthsToMap(map: Map, berths: BerthListDto[]): void {
  // Find the berths layer and add the berths as features
  map.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (
          lay.get("title") === LayerTitle.Berths &&
          lay instanceof VectorLayer
        ) {
          const source = lay.getSource();
          // Clear the source before adding
          source.clear();
          const features = berths.map((p) => {
            const poly = new Polygon([
              p.points.map((point) => [point.x, point.y]),
            ]);
            const feat = new Feature({
              geometry: poly,
              name: p.name,
            });
            // Convert to internal type
            const convertedBerth = berthToMapItem(p);
            feat.setProperties({ ...convertedBerth });
            feat.setId(convertedBerth.mapId);
            return feat;
          });
          source.addFeatures(features);
          source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
          map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
        }
      });
    }
  });
}

export function removeAllBerthsFromMap(map: Map): void {
  map.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (
          lay.get("title") === LayerTitle.Berths &&
          lay instanceof VectorLayer
        ) {
          const source = lay.getSource();
          // Clear the sourc
          source.clear();
          source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
          map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
        }
      });
    }
  });
}
